<label id="customDropdownLabel">Sort by</label>
<div class="filter">
  <button
    #triggerButton
    id="customDropdownBtn"
    (click)="toggleDropdown()"
    readonly
    type="button"
    class="filter-Val clickable"
    aria-haspopup="true"
    aria-labelledby="customDropdownLabel customDropdownBtn"
    [attr.aria-expanded]="dropdownShown">
    <div>{{label}}</div>
  </button>
  <label (click)="toggleDropdown()" class="noselect filter-Toggle"></label>

  @if (dropdownShown) {
    <ul
      class="filter-options"
      role="listbox"
      [attr.aria-hidden]="!dropdownShown"
      aria-labelledby="customDropdownLabel"
      tabindex="-1">
      @for (key of optionKeys; track key; let i = $index) {
        <li
          [id]="'filter-option-' + i"
          class="filter-options__item"
          (click)="onOptionClick(key)"
          (keydown)="onOptionKeydown($event, key)"
          (blur)="onOptionBlur($event)"
          [class.selected]="options[key] === label"
          role="option"
          tabindex="-1">
          {{options[key]}}
        </li>
      }
    </ul>
  }
</div>